import { Box, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import { ReactComponent as VulnerabilitiesIcon } from "../../../environment/icons/sidebar_icons/sidebar-icons-vulnerabilities.svg";
import PotentialCollapsibleSection from "./PotentialCollapsibleSection";

export const CVE_SECTION_CLASSNAME = "cve-section";

export default function CVESection({ displayName }) {
  const colors = useColors();
  return (
    <PotentialCollapsibleSection
      title="CVEs & Vulnerabilities"
      Icon={VulnerabilitiesIcon}
    >
      <div
        className={CVE_SECTION_CLASSNAME}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "8px 0",
        }}
      >
        <Box display="flex" gap={1} flexDirection="column">
          <Typography variant="body2" color={colors.text_primary}>
            By connecting {displayName} to Breeze, vulnerabilities tied to your
            environment are continuously surfaced and enriched with
            exploitability and impact context, enabling you to prioritize the
            most critical risks and accelerate effective remediation.
          </Typography>
        </Box>
      </div>
    </PotentialCollapsibleSection>
  );
}
